import './styles.scss'

interface Props {
  title: string
  message?: string
}

export const Notification = (props: Props) => {
  const { title, message } = props

  return (
    <div className="notification">
      <div>{title}</div>
      {message && <div className="message">{message}</div>}
    </div>
  )
}
